module.exports = require('../manifest.json').version



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 9
// module chunks = 0